import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { EGDSIcon } from '../../icons/icon/index.esm.js';
import '../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../layout-flex/layout-flex-item/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-step-input.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { liveAnnounce, Level } from '../../utils/live-announce/index.esm.js';
import { EGDSContextWrapper } from '../../utils/context-provider/index.esm.js';
import { analyticsTracker } from '../../utils/analytics-tracker/index.esm.js';
const getClassNameList = classNames.bind(styles);
var EGDSStepInputLocalAnalyticsIdType;
(function (EGDSStepInputLocalAnalyticsIdType) {
  EGDSStepInputLocalAnalyticsIdType["add"] = "Add";
  EGDSStepInputLocalAnalyticsIdType["remove"] = "Remove";
})(EGDSStepInputLocalAnalyticsIdType || (EGDSStepInputLocalAnalyticsIdType = {}));
const generateUniqueId = (label, operationMethod) => {
  const newOperationMethod = operationMethod ? `${operationMethod}-` : '';
  const randomNumber = Math.floor(Math.random() * 1000);
  return `uitk-step-${newOperationMethod}${label.toLowerCase()}-${randomNumber.toString()}`;
};
class EGDSStepInput extends React.Component {
  static displayName = 'EGDSStepInput';
  static defaultProps = {
    max: 99,
    min: 0,
    step: 1,
    value: 0
  };
  containerRef = React.createRef();
  liveAnnounceContainerID = `id-${Math.random().toString(36).substring(7)}`;
  inputId;
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false
    };
    this.setInputId = this.setInputId.bind(this);
  }
  componentDidMount() {
    this.setState({
      isMounted: true
    });
  }
  getDecrementIconId() {
    const {
      decrementId,
      label
    } = this.props;
    return decrementId || generateUniqueId(label, 'decrement');
  }
  getIncrementIconId() {
    const {
      incrementId,
      label
    } = this.props;
    return incrementId || generateUniqueId(label, 'increment');
  }
  setInputId() {
    const {
      id,
      label
    } = this.props;
    this.inputId = id || generateUniqueId(label);
  }
  decrement = () => {
    const {
      step,
      value
    } = this.props;
    const newValue = Number(value);
    const result = newValue - step;
    this.changeValue(result);
  };
  increment = () => {
    const {
      step,
      value
    } = this.props;
    const newValue = Number(value);
    const result = newValue + step;
    this.changeValue(result);
  };
  inputChange = event => this.changeValue(event.target.value);
  changeValue = value => {
    const {
      onChange,
      min,
      max,
      label
    } = this.props;
    const changedValue = {
      target: {
        value: value.toString()
      }
    };
    if (value < min || value > max) {
      return null;
    }
    liveAnnounce(`${value.toString()} ${label}`, Level.POLITE, undefined, this.containerRef, this.liveAnnounceContainerID);
    if (onChange) {
      onChange(changedValue);
    }
  };
  render() {
    const {
      isMounted
    } = this.state;
    const {
      decrementText,
      incrementText,
      className,
      analytics,
      description,
      decrementRef,
      incrementRef,
      value,
      label,
      step,
      min,
      max,
      required
    } = this.props;
    const ariaLabel = [label, description].filter(elem => !!elem).toString();
    const isNextDecrementUnderMinimum = Number(value) - step < min;
    const isNextIncrementAboveMaximum = Number(value) + step > max;
    const isDecrementDisabled = !isMounted || isNextDecrementUnderMinimum;
    const isIncrementDisabled = !isMounted || isNextIncrementAboveMaximum;
    const inputType = isMounted ? 'text' : 'number';
    const inputTabIndex = isMounted ? -1 : 0;
    const baseClassName = 'uitk-step-input';
    const wrapperClassNames = getClassNameList(`${baseClassName}`, className, {
      'uitk-step-input-mounted': isMounted
    });
    const labelCssClassName = getClassNameList(`${baseClassName}-label-section`, {
      'is-required': required
    });
    const decrementAnalytics = analytics && {
      localAnalyticsId: EGDSStepInputLocalAnalyticsIdType.remove,
      ...analytics
    };
    const incrementAnalytics = analytics && {
      localAnalyticsId: EGDSStepInputLocalAnalyticsIdType.add,
      ...analytics
    };
    this.setInputId();
    return jsx(EGDSContextWrapper, {
      children: (context, data) => jsxs(EGDSLayoutFlex, {
        className: wrapperClassNames,
        alignItems: "center",
        justifyContent: "space-between",
        domRef: this.containerRef,
        children: [jsx(EGDSLayoutFlexItem, {
          className: labelCssClassName,
          grow: 1,
          children: jsxs("label", {
            htmlFor: this.inputId,
            children: [label && jsxs("span", {
              className: getClassNameList(`${baseClassName}-label`),
              children: [label, required && (data && !data?.hasRequiredFieldIndicator ? null : jsxs("span", {
                "aria-hidden": "true",
                className: getClassNameList('uitk-step-input-required-asterisk'),
                children: [' ', "*"]
              }))]
            }), description && jsx("span", {
              className: getClassNameList(`${baseClassName}-description`),
              children: description
            })]
          })
        }), jsx(EGDSLayoutFlexItem, {
          className: getClassNameList(`${baseClassName}-controls`),
          children: jsxs(EGDSLayoutFlex, {
            children: [jsx(EGDSLayoutFlexItem, {
              className: getClassNameList(`${baseClassName}-touch-target`),
              children: jsx("button", {
                type: "button",
                disabled: isDecrementDisabled,
                onClick: this.decrement,
                onClickCapture: analyticsTracker.bind(this, decrementAnalytics),
                ref: decrementRef,
                children: jsx("span", {
                  className: getClassNameList(`${baseClassName}-button`),
                  children: jsx(EGDSIcon, {
                    className: getClassNameList(`${baseClassName}-icon`),
                    name: "remove",
                    title: decrementText,
                    id: this.getDecrementIconId()
                  })
                })
              })
            }), jsx(EGDSLayoutFlexItem, {
              className: getClassNameList(`${baseClassName}-value`),
              children: jsx("input", {
                type: inputType,
                id: this.inputId,
                value: value,
                onChange: this.inputChange,
                min: min,
                max: max,
                tabIndex: inputTabIndex,
                readOnly: isMounted,
                "aria-label": ariaLabel
              })
            }), jsx(EGDSLayoutFlexItem, {
              className: getClassNameList(`${baseClassName}-touch-target`),
              children: jsx("button", {
                type: "button",
                disabled: isIncrementDisabled,
                onClick: this.increment,
                onClickCapture: analyticsTracker.bind(this, incrementAnalytics),
                ref: incrementRef,
                children: jsx("span", {
                  className: getClassNameList(`${baseClassName}-button`),
                  children: jsx(EGDSIcon, {
                    className: getClassNameList(`${baseClassName}-icon`),
                    name: "add",
                    title: incrementText,
                    id: this.getIncrementIconId()
                  })
                })
              })
            })]
          })
        })]
      })
    });
  }
}
export { EGDSStepInput, EGDSStepInputLocalAnalyticsIdType };